import { BaseQueryFn } from '@reduxjs/toolkit/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

/**
 * TODODEV : faire accepter import.meta à Typescrip puis retirer les @ts-ignore ci-dessous
 */
const axiosInstance = axios.create({
  // @ts-ignore
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const auth = localStorage.getItem('auth');

  if (auth) {
    const stored = JSON.parse(auth);
    if (stored.token !== '' && stored.token !== null) {
      config.headers['Authorization'] = `Bearer ${stored.token}`;
    }
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (resp) => {
    return resp;
  },
  (error) => {
    if (
      [
        'Votre jeton est invalide, merci de vous reconnecter pour en obtenir un nouveau',
        'Votre session a expirée, merci de la renouveller en vous déconnectant et en vous reconnectant à nouveau',
      ].includes(error.response.data.message)
    ) {
      localStorage.removeItem('auth');
      location.reload();
    }
    return Promise.reject(error);
  }
);

export const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string | undefined } = { baseUrl: '' }
  ): BaseQueryFn<{
    url: string;
    method: AxiosRequestConfig['method'];
    data?: AxiosRequestConfig['data'];
    params?: AxiosRequestConfig['params'];
    headers?: AxiosRequestConfig['headers'];
    responseType?: AxiosRequestConfig['responseType'];
  }> =>
  async ({ url, method, data, params, headers, responseType }) => {
    try {
      const result = await axiosInstance({
        url: baseUrl + url,
        method,
        data,
        params,
        headers,
        responseType,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export default axiosInstance;
